export default[
  {
    path: '/mall2/orderlist',
    name: 'mall2Orderlist',
    meta: {
      title: '积分商城',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/orderlist'], resolve)
    }
  },
  {
    path: '/mall2/index',
    name: 'mall2Index',
    meta: {
      title: '积分商城',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/mallIndex'], resolve)
    }
  },
  {
    path: '/mall2/spike',
    name: 'mall2Spike',
    meta: {
      title: '商品秒杀列表',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/spike-list'], resolve)
    }
  },
  {
    path: '/mall2/product/list',
    name: 'mall2ProductList',
    meta: {
      title: '商品列表',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/productList'], resolve)
    }
  },
  {
    path: '/mall2/product/detail/:id',
    name: 'mall2ProductDetail',
    meta: {
      title: '商品详情',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/product-detail'], resolve)
    }
  },
  {
    path: '/mall2/sumbitOrder/:id',
    name: 'mall2SubmitOrders',
    meta: {
      title: '填写订单',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/SubmitOrders'], resolve)
    }
  },
  {
    path: '/mall2/sumbitOrder2/:id',
    name: 'mall2SubmitSApikeOrders',
    meta: {
      title: '填写订单',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/SubmitSpikeOrders'], resolve)
    }
  },
  {
    path: '/mall2/product/pingjia/:id',
    name: 'mall2pingjia',
    meta: {
      title: '商品评价',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/pingjialist'], resolve)
    }
  },
  {
    path: '/mall2/product/evaluate/:orderid',
    name: 'mall2evaluate',
    meta: {
      title: '评价',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/evaluate'], resolve)
    }
  },
  {
    path: '/mall2/order/logistics/:orderid',
    name: 'mall2logistics',
    meta: {
      title: '物流详情',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/logistics'], resolve)
    }
  },
  {
    path: '/mall2/order/complaint/:id/:orderid',
    name: 'mall2complaint',
    meta: {
      title: '投诉',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/complaint'], resolve)
    }
  },
  {
    path: '/mall2/order/detail/:id',
    name: 'mall2OrderDetail',
    meta: {
      title: '积分商城',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mall2/order-detail'], resolve)
    }
  }
]
